// Lightweight first-party analytics client
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function uuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getVisitorId() {
  let id = localStorage.getItem("tcs_vid");
  if (!id) {
    id = uuid();
    localStorage.setItem("tcs_vid", id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem("tcs_sid");
  if (!id) {
    id = uuid();
    sessionStorage.setItem("tcs_sid", id);
  }
  return id;
}

function getDevice() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function track(type, extra = {}) {
  try {
    const payload = {
      type,
      path: window.location.pathname || "/",
      lang: localStorage.getItem("tcs_lang") || "en",
      device: getDevice(),
      referrer: document.referrer || "",
      label: extra.label || "",
      value: extra.value != null ? extra.value : null,
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
    };
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* no-op: analytics must never break the UI */
  }
}

export function trackPageview() {
  track("pageview");
}
